const resourceAI = [
  {
    title: '微軟IoT Central',
    alias: 'alais-1',
    category: 'AI+ML',
    class: [
      {
        alias: '影像辨識',
        title: '影像辨識'
      },
      {
        alias: '語音辨識',
        title: '語音辨識'
      }
    ],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_f8e2964d9cbc961bacf4e77598972bbe.jpg'
  },
  {
    title: '微軟資源網路應用服務',
    category: 'AI+ML',
    alias: 'alais-2',
    class: [{
      alias: '影像辨識',
      title: '影像辨識'
    },
    {
      alias: '語音辨識',
      title: '語音辨識'
    }],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_f8e2964d9cbc961bacf4e77598972bbe.jpg'
  },
  {
    title: '微軟測次文字測試文字測試文字',
    category: 'AI+ML',
    alias: 'alais-3',
    class: [{
      alias: '影像辨識',
      title: '影像辨識'
    }],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_ea7e7ff73736508273ae7772fa46e07a.jpg'
  },
  {
    title: '微軟資源網路應用服務測試文字測試文字測試文字',
    category: 'AI+ML',
    alias: 'alais-4',
    class: [{
      alias: '影像辨識',
      title: '影像辨識'
    },
    {
      alias: '語音辨識',
      title: '語音辨識'
    },
    {
      alias: '整合開發',
      title: '整合開發'
    },
    {
      alias: '自然語意',
      title: '自然語意'
    }],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_ea7e7ff73736508273ae7772fa46e07a.jpg'
  },
  {
    title: '微軟IoT Central',
    alias: 'alais-5',
    category: 'AI+ML',
    class: [{
      alias: '語音辨識',
      title: '語音辨識'
    },
    {
      alias: '整合開發',
      title: '整合開發'
    },
    {
      alias: '自然語意',
      title: '自然語意'
    }],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_f8e2964d9cbc961bacf4e77598972bbe.jpg'
  },
  {
    title: '微軟資源網路應用服務',
    category: 'AI+ML',
    alias: 'alais-6',
    class: [{
      alias: '整合開發',
      title: '整合開發'
    },
    {
      alias: '自然語意',
      title: '自然語意'
    }],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_ea7e7ff73736508273ae7772fa46e07a.jpg'
  },
  {
    title: '微軟測次文字測試文字測試文字',
    category: 'AI+ML',
    alias: 'alais-7',
    class: [{
      alias: '整合開發',
      title: '整合開發'
    },],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_f8e2964d9cbc961bacf4e77598972bbe.jpg'
  },
  {
    title: '微軟資源網路應用服務',
    category: 'AI+ML',
    alias: 'alais-8',
    class: [{
      alias: '影像辨識',
      title: '影像辨識'
    },
    {
      alias: '語音辨識',
      title: '語音辨識'
    },
    {
      alias: '整合開發',
      title: '整合開發'
    },
    {
      alias: '自然語意',
      title: '自然語意'
    },
    {
      alias: '深入學習',
      title: '深入學習'
    },
  ],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_ea7e7ff73736508273ae7772fa46e07a.jpg'
  },
  {
    title: '微軟資源網路應用服務',
    category: 'AI+ML',
    alias: 'alais-9',
    class: [{
      alias: '整合開發',
      title: '整合開發'
    },
    {
      alias: '自然語意',
      title: '自然語意'
    },
    {
      alias: '深入學習',
      title: '深入學習'
    },],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_ea7e7ff73736508273ae7772fa46e07a.jpg'
  },
]


const resourceIoT = [
  {
    title: 'Iot微軟IoT Central',
    alias: 'alais-1',
    category: 'AI+ML',
    class: [
      {
        alias: '影像辨識',
        title: '影像辨識'
      },
      {
        alias: '語音辨識',
        title: '語音辨識'
      }
    ],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_f8e2964d9cbc961bacf4e77598972bbe.jpg'
  },
  {
    title: 'Iot微軟資源網路應用服務',
    category: 'AI+ML',
    alias: 'alais-2',
    class: [{
      alias: '影像辨識',
      title: '影像辨識'
    },
    {
      alias: '語音辨識',
      title: '語音辨識'
    }],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_f8e2964d9cbc961bacf4e77598972bbe.jpg'
  },
  {
    title: 'Iot微軟測次文字測試文字測試文字',
    category: 'AI+ML',
    alias: 'alais-3',
    class: [{
      alias: '影像辨識',
      title: '影像辨識'
    }],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_ea7e7ff73736508273ae7772fa46e07a.jpg'
  },
  {
    title: 'Iot微軟資源網路應用服務測試文字測試文字測試文字',
    category: 'AI+ML',
    alias: 'alais-4',
    class: [{
      alias: '影像辨識',
      title: '影像辨識'
    },
    {
      alias: '語音辨識',
      title: '語音辨識'
    },
    {
      alias: '整合開發',
      title: '整合開發'
    },
    {
      alias: '自然語意',
      title: '自然語意'
    }],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_ea7e7ff73736508273ae7772fa46e07a.jpg'
  },
  {
    title: 'Iot微軟IoT Central',
    alias: 'alais-5',
    category: 'AI+ML',
    class: [{
      alias: '語音辨識',
      title: '語音辨識'
    },
    {
      alias: '整合開發',
      title: '整合開發'
    },
    {
      alias: '自然語意',
      title: '自然語意'
    }],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_f8e2964d9cbc961bacf4e77598972bbe.jpg'
  },
  {
    title: 'Iot微軟資源網路應用服務',
    category: 'AI+ML',
    alias: 'alais-6',
    class: [{
      alias: '整合開發',
      title: '整合開發'
    },
    {
      alias: '自然語意',
      title: '自然語意'
    }],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_ea7e7ff73736508273ae7772fa46e07a.jpg'
  },
  {
    title: 'Iot微軟測次文字測試文字測試文字',
    category: 'AI+ML',
    alias: 'alais-7',
    class: [{
      alias: '整合開發',
      title: '整合開發'
    },],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_f8e2964d9cbc961bacf4e77598972bbe.jpg'
  },
  {
    title: 'Iot微軟資源網路應用服務',
    category: 'AI+ML',
    alias: 'alais-8',
    class: [{
      alias: '影像辨識',
      title: '影像辨識'
    },
    {
      alias: '語音辨識',
      title: '語音辨識'
    },
    {
      alias: '整合開發',
      title: '整合開發'
    },
    {
      alias: '自然語意',
      title: '自然語意'
    },
    {
      alias: '深入學習',
      title: '深入學習'
    },
  ],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_ea7e7ff73736508273ae7772fa46e07a.jpg'
  },
  {
    title: 'Iot微軟資源網路應用服務',
    category: 'AI+ML',
    alias: 'alais-9',
    class: [{
      alias: '整合開發',
      title: '整合開發'
    },
    {
      alias: '自然語意',
      title: '自然語意'
    },
    {
      alias: '深入學習',
      title: '深入學習'
    },],
    introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_ea7e7ff73736508273ae7772fa46e07a.jpg'
  },
]

export const FAKE_RESOURCE= {
  items: {
    'AlMl': {
      items: [...resourceAI],
      title: 'AL+ML'
    },
    'iot': {
      items: [...resourceIoT],
      title: 'IoT & Data Analytics'
    },
    'devops': {
      items: [...resourceAI],
      title: 'DevOps'
    },
    'infrastructure': {
      items: [...resourceIoT],
      title: 'Infrastructure'
    },
    'business': {
      items: [...resourceAI],
      title: 'Business Application'
    }
  }
}


export const FAKE_RESOURCEITEM = {
  alias: 'resource-1',
  title: '微軟IoT Central',
  category: [{
    alias: '自然語意',
    title: '自然語意'
  },
  {
    alias: '影像辨識',
    title: '影像辨識'
  }],
  introimage: require('@assets/images/news/newsItem@2.jpg'),
  publish_up: '2021-10-20',
  tags: [{
    alias: '整合開發',
    title: '整合開發'
  },
  {
    alias: '自然語意',
    title: '自然語意'
  },
  {
    alias: '深入學習',
    title: '深入學習'
  }], // '媒體傳播', '醫療', '遊戲', '能源', '製造', '建築'
  description: `<h3>使用雙向通信構建您的 IoT 應用程序</h3><br><br><p>在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。<br>Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。 <br><br>在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。 在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。 在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。 在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。<br><br>在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。 在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。在您的物聯網 (IoT) 應用程序與其管理的設備之間實現高度安全和可靠的通信。Microsoft IoT 中心提供了一個雲託管解決方案後端，幾乎可以連接任何設備。通過每設備身份驗證、內置設備管理和擴展配置，將您的解決方案從雲擴展到邊緣。</p>`,
  prev: {title: "人臉識別門禁考勤管理系統", alias: "solution-2"},
  next: {title: "V5 聲學槍聲傳感器 (V5 GSL)", alias: "solution-3"},
  solutions: [
    {
      title: '智能空間',
      alias: 'solution-1',
      category: 'AI+ML',
      class: [{
        alias: '整合開發',
        title: '整合開發'
      },],
      description: '幫助城市和組織變得更安全、更智能',
      author: 'Hitachi',
      publish_up: '2021/10/20',
      introimage: null
    },
    {
      title: '微軟資源網路應用服務',
      category: 'AI+ML',
      alias: 'solution-2',
      class: [{
          alias: '自然語意',
          title: '自然語意'
        },
        {
          alias: '遊戲',
          title: '遊戲'
        },
        {
          alias: '自然語意',
          title: '自然語意'
        },
      ],
      description: '幫助城市和組織變得更安全、更智能測試文字測試文字',
      author: '微軟中心',
      publish_up: '2021/10/20',
      introimage: null
    },
    {
      title: '微軟測次文字測試文字測試文字',
      category: 'AI+ML',
      alias: 'alais-3',
      class: [{
        alias: '自然語意',
        title: '自然語意'
      }],
      description: '幫助城市和組織變得更安全、更智能',
      author: 'Hitachi',
      publish_up: '2021/10/20',
      introimage: null
    },
  ],
  extrafields: {
    slideshow: {
      "id": 1,
      "type": "img",
      "alias": "slideshow",
      "title": "輪播",
      "value": null,
      "params": [
        {
          img: require('@assets/images/resource/resourceItem1@2.jpg'),
          alias: 'slideshow-1'
        },
        {
          img: require('@assets/images/resource/resourceItem2@2.jpg'),
          alias: 'slideshow-2'
        },
        {
          img: require('@assets/images/resource/resourceItem3@2.jpg'),
          alias: 'slideshow-3'
        },
        {
          img: require('@assets/images/resource/resourceItem4@2.jpg'),
          alias: 'slideshow-4'
        },
        {
          img: require('@assets/images/resource/resourceItem5@2.jpg'),
          alias: 'slideshow-5'
        }
      ]
    },
    youtube_url: {
      "id": 27,
      "type": "text",
      "alias": "youtube_url",
      "title": "Machinelink 工業物聯網解決方案",
      "value": "https://www.youtube.com/watch?v=AbuZvofz-PU",
      "description": "幫助城市和組織變得更安全、更智能",
      "time": '2分鐘',
      "params": []
    },
  },
  resources: [
    {
      title: '微軟IoT Central',
      alias: 'alais-1',
      category: 'AI+ML',
      class: [{
        alias: '自然語意',
        title: '自然語意'
      }],
      introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_f8e2964d9cbc961bacf4e77598972bbe.jpg'
    },
    {
      title: '微軟資源網路應用服務',
      category: 'AI+ML',
      alias: 'alais-2',
      class: [
        {
          alias: '自然語意',
          title: '自然語意'
        },
        {
          alias: '遊戲',
          title: '遊戲'
        },
      ],
      introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_f8e2964d9cbc961bacf4e77598972bbe.jpg'
    },
    {
      title: '微軟測次文字測試文字測試文字',
      category: 'AI+ML',
      alias: 'alais-3',
      class: [ 
        {
          alias: '遊戲',
          title: '遊戲'
        }
      ],
      introimage: 'https://s3-ap-northeast-1.amazonaws.com/g0v-hackmd-images/uploads/upload_ea7e7ff73736508273ae7772fa46e07a.jpg'
    },
  ],
  files: [
    {
      alias: 'file-1',
      title: "微軟IoT Central 詳細說明書",
      downloadLink: 'test.pdf',
      categoryTitle: '說明書'
    },
    {
      alias: 'file-2',
      title: "微軟IoT Central 白皮書",
      downloadLink: 'test.pdf',
      categoryTitle: '白皮書'
    }
  ]
}